// AudioStreamSender.ts
import logger from '@/utils/logger';
import globalHxxlConfig from '@/lib/HxxlConfig';

export class AudioStreamSender {
  private buffer: any[] = [];

  private bufferSize: number = 10;

  private sessionId: string;

  private wsUrl: string;

  private ws: WebSocket | null = null;

  private mediaRecorder: MediaRecorder | null = null;

  private chunks: Blob[] = [];

  private uploadUrl: string = "https://ai.hubeixinli.com/aitalk/upload-video";

  private video_track:MediaStreamTrack | null = null;

  start_video(track: MediaStreamTrack) {
    if (this.video_track == null){
      this.video_track = track;
    } else {
      return;
    }
    const stream = new MediaStream([track]);
    
    this.mediaRecorder = new MediaRecorder(stream, {
      mimeType: 'video/webm;codecs=vp9'
    });

    this.chunks = [];

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.chunks.push(event.data);
      }
    };

    this.mediaRecorder.onstop = async () => {
      await this.uploadVideo();
    };

    this.mediaRecorder.onerror = (event) => {
      console.error('录制错误:', event);
    };

    this.mediaRecorder.start();
    console.log('开始录制...');
  }

  stop_video() {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
      console.log('停止录制...');
    }
  }

  private async uploadVideo() {
    const blob = new Blob(this.chunks, { type: 'video/webm' });
    console.log(`准备上传视频，大小: ${(blob.size / 1024 / 1024).toFixed(2)} MB`);

    const formData = new FormData();
    formData.append('file', blob, `video_${Date.now()}.webm`);
    formData.append('uid', globalHxxlConfig.getUid() || '');
    formData.append('owner', globalHxxlConfig.getOwner() || '');
    formData.append('talkId', globalHxxlConfig.getTalkId() || '');
    formData.append('timestamp', Date.now().toString());

    try {
      const response = await fetch(this.uploadUrl, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const result = await response.json();
        console.log('上传成功:', result);
        // return result;
      } else {
        const error = await response.text();
        console.error('上传失败:', error);
        throw new Error(error);
      }
    } catch (error) {
      console.error('上传错误:', error);
      throw error;
    }
  }


  constructor() {
    this.wsUrl = 'wss://aitalk.hubeixinli.com/aitalk/ws/audio';
    this.sessionId = this.generateSessionId();
  }

  private generateSessionId(): string {
    return `audio_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  async connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.ws = new WebSocket(this.wsUrl);

      this.ws.onopen = () => {
        logger.log('WebSocket 连接成功');
        this.ws?.send(JSON.stringify({
          type: 'init',
          sessionId: this.sessionId,
          owner: globalHxxlConfig.getOwner(),
          uid: globalHxxlConfig.getUid(),
          talkId: globalHxxlConfig.getTalkId(),
          timestamp: Date.now()
        }));
        resolve();
      };

      this.ws.onerror = (error) => {
        logger.error('WebSocket 错误:', error);
        reject(error);
      };

      this.ws.onclose = () => {
        logger.log('WebSocket 连接关闭');
      };
    });
  }

  handleAudioFrame(audioFrame: any, userId: string): void {
    this.buffer.push({ data: audioFrame, userId, timestamp: Date.now() });
    if (this.buffer.length >= this.bufferSize) {
      this.sendBuffer();
    }
  }

  private sendBuffer(): void {
    if (this.buffer.length === 0 || !this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    
    const payload = {
      type: 'audio_data',
      sessionId: this.sessionId,
      owner: globalHxxlConfig.getOwner(),
      uid: globalHxxlConfig.getUid(),
      talkId: globalHxxlConfig.getTalkId(), 
      frames: this.buffer,
      timestamp: Date.now()
    };

    this.ws.send(JSON.stringify(payload));
    this.buffer = [];
  }

  flush(): void {
    this.sendBuffer();
  }

  async stop(): Promise<void> {
    this.flush();

    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({
        type: 'end',
        sessionId: this.sessionId,
        owner: globalHxxlConfig.getOwner(),
        uid: globalHxxlConfig.getUid(),
        talkId: globalHxxlConfig.getTalkId(),
        timestamp: Date.now()
      }));
      await new Promise(resolve => {setTimeout(resolve, 100)});
      this.ws.close();
    }
  }
}


export default AudioStreamSender

